import { render, staticRenderFns } from "./HighlightingAlert.vue?vue&type=template&id=5889d0cd&scoped=true&"
import script from "./HighlightingAlert.vue?vue&type=script&lang=js&"
export * from "./HighlightingAlert.vue?vue&type=script&lang=js&"
import style0 from "./HighlightingAlert.vue?vue&type=style&index=0&id=5889d0cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889d0cd",
  null
  
)

export default component.exports